import { render, staticRenderFns } from "./job-details.vue?vue&type=template&id=5b9b2cd4&"
import script from "./job-details.vue?vue&type=script&lang=js&"
export * from "./job-details.vue?vue&type=script&lang=js&"
import style0 from "./job-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSkeleton,QIcon,QAvatar} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSkeleton,QIcon,QAvatar})
